import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FooterRecherchePictoProps extends pictoProps {
}

export interface FooterRecherchePictoState extends pictoState {
}

export class FooterRecherchePicto extends Picto<FooterRecherchePictoProps,FooterRecherchePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerRecherchePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterRecherchePicto);
